export default function ({ redirect }) {
  redirect('/not-found')
}
